import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import JobsHome from "./Jobs/JobsHome";
import { Space, Select, Input, Modal, Tooltip } from "antd";
import { useProjectProvider } from "../../../Providers/Vendor/Project";
import { useJobProvider } from "../../../Providers/Vendor/Jobs";
import Swal from "sweetalert2";
import DatePicker from "../../../Components/DatePicker";
import Back from "../../../Components/Back";
import SimpleBackDrop from "../../../Components/SimpleBackDrop";
import { useCountryStateCityProvider } from "../../../Providers/Common/CountyStateCity";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";

export default function Jobs({
  id,
  setActive,
  setProjectStatus,
  setProject,
  projectouter,
}) {
  const defaultJobDetails = {
    created_by: localStorage.getItem("userId"),
    projectId: "",
    name: "",
    description: "",
    country: "",
    city: "",
    state: "",
    start_date: "",
    rate: "",
    primary_skill: "",
    location: "REMOTE",
    main_skill: "",
    other_skills: [],
    attachment_link: "",
    status: "Posted",
    project: "",
    isPublicalyVisible: false
  };

  const [jobType, setJobType] = useState("Hourly/ Contract");
  const [postJob, setPostJob] = useState(false);
  const [open, setOpen] = useState(false);
  const [jobDescriptionLength, setJobDescriptionLength] = useState(0);
  const [jobDetails, setJobDetails] = useState(defaultJobDetails);
  const [loading, setLoading] = useState(false);
  const [stateIsoCode, setStateIsoCode] = useState("");
  const [jobId, setJobId] = useState(null);
  const [tempProjectId, setTempProjectId] = useState()
  const [projectId, setProjectId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation()
  const showModal = () => setOpen(true);
  const handleOk = () => setOpen(false);
  const handleCancel = () => setOpen(false);

  const handleJobDetailsChange = (value, name) => {
    if(name==="isPublicalyVisible"){
      setJobDetails({...jobDetails, isPublicalyVisible: !jobDetails.isPublicalyVisible})
    }else{
      if (value === "Add Project") showModal();
      setJobDetails({ ...jobDetails, [name]: value ? value : "" });
    }
  };

  const { getAllSkills, skills } = useJobProvider();
  const {
    countries,
    states,
    cities,
    getCountries,
    getStatesByCountry,
    getCitiesByStateAndCountry,
  } = useCountryStateCityProvider();

  useEffect(() => {
    getAllSkills();
    getCountries();
  }, []);

  const { projects, addProject, fetchProjects } = useProjectProvider();
  const { addJob, fetchJobDetails, updateJob } = useJobProvider();
  const addProjectWrapper = async () => {
    const data = await addProject(project);
    if (data.success) {
      Swal.fire({
        title: "Project posted successfully",
        icon: "success",
      }).then(() => {
        setOpen(false);
        handleJobDetailsChange(data.id, "projectId");
      });
    } else {
      Swal.fire({
        title: "Unable to add new project",
        icon: "error",
      }).then(handleOk);
    }
  };

  useEffect(() => {
    fetchProjects();
    getAllSkills();
    setJobDescriptionLength(0);
    setJobDetails({
      ...jobDetails,
    });
    getCountries();
    getStatesByCountry(jobDetails?.country);
  }, [jobDetails?.country]);

  const [project, setProjects] = useState({
    userId: localStorage.getItem("userId"),
    ownerId: "",
    projectTitle: "",
    projectDetail: "",
  });

  useEffect(() => {
    if (jobId && postJob) {
      fetchJobDetails(jobId).then(setJobDetails);
    }
  }, [jobId])

  useEffect(() => {
    if (id) {
      setJobId(id)
    }
  }, [id])

  return (
    <div
      style={{ backgroundColor: !postJob ? "#f5f5f5" : "white" }}
      className={`${postJob && "p-4"} mb-4 font-[Roboto] bg-white rounded-lg`}
    >
      <SimpleBackDrop open={loading} />
      {!postJob ? (
        <JobsHome
          setProjectStatus={setProjectStatus}
          setProject={setProject}
          project={projectouter}
          setJobType={setJobType}
          setPostJob={setPostJob}
          setActive={setActive}
          jobId={jobId}
          setJobId={setJobId}
        />
      ) : (
        <>
          <div>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue={jobType}
            >
              <div className="grid grid-cols-2 md:grid-cols-3 w-full items-center">
                <div className="flex flex-row space-x-2">
                  <Back
                    onClick={() => {
                      setPostJob(false);
                      setJobId(null)
                      setJobDescriptionLength(0);
                      setJobDetails(defaultJobDetails)
                      // setJobDetails({
                      //   ...jobDetails,
                      //   description: "",
                      //   location: "REMOTE",
                      // });
                    }}
                  />
                  <span className="mt-0.5">Select Job Type</span>
                </div>

                <div className="text-left">
                  <FormControlLabel
                    value="Hourly/ Contract"
                    control={
                      <Radio
                        onChange={(e) => {
                          setJobType(e.target.value);
                          setJobDescriptionLength(0);
                          setJobDetails({
                            ...jobDetails,
                            description: "",
                            location: "REMOTE",
                          });
                        }}
                      />
                    }
                    label="Hourly/ Contract"
                  />
                </div>
                <div className="text-center flex justify-start">
                  <FormControlLabel
                    value="Project"
                    control={
                      <Radio
                        onChange={(e) => {
                          setJobType(e.target.value);
                          setJobDescriptionLength(0);
                          setJobDetails({
                            ...jobDetails,
                            description: "",
                          });
                        }}
                      />
                    }
                    label="Project"
                  />
                </div>
              </div>
            </RadioGroup>
          </div>
          {jobType === "Hourly/ Contract" ? (
            <form
              onSubmit={(e) => {
                setLoading(true);
                e.preventDefault();
                if (!jobDetails.start_date) {
                  Swal.fire({
                    icon: "error",
                    title: "Error...",
                    text: "Please select a Start Date.",
                  });
                } else if (jobId && (jobDetails.projectId === "Default Project" ||
                  jobDetails.projectId === "")) {
                  updateJob({ ...jobDetails, projectId: "" }).then((ok) => {
                    setLoading(false);
                    e.target.reset();
                    setJobDetails(defaultJobDetails)
                    setJobId(ok);
                    navigate(`/dashboard/jobs/${ok}`, {
                      state: { from: location },
                    });
                    // return ok ? setJobDetails(defaultJobDetails) : null;
                  });
                  e.target.reset();
                  setJobDetails(defaultJobDetails)
                  setJobId(null)
                  setPostJob(false);
                } else if (jobId) {
                  updateJob({ ...jobDetails }).then((ok) => {
                    setLoading(false);
                    e.target.reset();
                    setJobDetails(defaultJobDetails)
                    setJobId(ok);
                    navigate(`/dashboard/jobs/${ok}`, {
                      state: { from: location },
                    });
                    // return ok ? setJobDetails(defaultJobDetails) : null;
                  });
                  e.target.reset();
                  setJobDetails(defaultJobDetails)
                  setJobId(null)
                  setPostJob(false);
                }
                else if (
                  jobDetails.projectId === "Default Project" ||
                  jobDetails.projectId === ""
                ) {
                  const res = addJob({ ...jobDetails, projectId: "" });
                  res.then((ok) => {
                    setLoading(false);
                    e.target.reset();
                    setJobDetails(defaultJobDetails)
                    setJobId(ok);
                    navigate(`/dashboard/jobs/${ok}`, {
                      state: { from: location },
                    });
                    // return ok ? setJobDetails(defaultJobDetails) : null;
                  });
                  e.target.reset();
                  setJobDetails(defaultJobDetails)
                  setJobId(null)
                  setPostJob(false);
                } else {
                  const res = addJob(jobDetails);
                  res.then((ok) => {
                    setLoading(false);
                    e.target.reset();
                    setJobDetails(defaultJobDetails)
                    setJobId(ok);
                    navigate(`/dashboard/jobs/${ok}`, {
                      state: { from: location },
                    });
                    //return ok ? setJobDetails(defaultJobDetails) : null;
                  });
                  e.target.reset();
                  setJobDetails(defaultJobDetails)
                  setJobId(null)
                  setPostJob(false);
                }
              }}
            >
              <div className="mt-8">
                <div className="flex flex-col md:space-y-0 space-y-2">
                  <span>Job Title *</span>
                  <Input
                    required
                    value={jobDetails?.name}
                    placeholder="Enter Job Title"
                    className="h-[40px]"
                    onChange={(e) =>
                      handleJobDetailsChange(e.target.value, "name")
                    }
                  />
                </div>
                <div className="flex flex-col md:space-y-0 space-y-2 mt-8 ">
                  <span>
                    Job Description * &nbsp;
                    <span className="text-sm text-gray-400">
                      ({jobDescriptionLength}/3000 Characters)
                    </span>
                  </span>
                  <textarea
                    required
                    value={jobDetails?.description}
                    className="border-[1px] border-[#C6C6C6] border-solid"
                    style={{
                      borderRadius: "4px",
                      width: "100%",
                      height: "154px",
                      paddingLeft: "10px",
                    }}
                    onChange={(e) => {
                      handleJobDetailsChange(e.target.value, "description");
                      setJobDescriptionLength(e.target.value.length);
                    }}
                  />
                  {/* <MyEditor updateRaw={setEditorData} html={""} /> */}
                  {jobDescriptionLength > 3000 ? (
                    <span className="text-sm text-red-500">
                      Max 3000 Characters are allowed
                    </span>
                  ) : null}
                </div>
              </div>
              <div className="flex flex-col justify-between mt-8">
                <div className="flex flex-col w-full">
                  <span>Skills</span>
                  <FormControl className="w-full" fullWidth>
                    <Tooltip placement="topLeft" title="Hit Enter  key to add skill after typing a skill" color={"#2EBAA3"} key={"#2EBAA3"}>
                      <Select
                        style={{ width: "100%" }}
                        listHeight={128}
                        mode="tags"
                        value={jobDetails?.main_skill?.length > 0 ? jobDetails?.main_skill : []}
                        placeholder="Please select"
                        onChange={(e) => handleJobDetailsChange(e, "main_skill")}
                        options={skills.map((skill) => {
                          return { value: skill.name, label: skill.name };
                        })}
                        className="grow"
                      />
                    </Tooltip>
                  </FormControl>
                </div>

                <div className="flex mt-4 flex-row-reverse justify-between">
                  <div className="flex flex-col">
                    <div className="flex flex-col">
                      <span>Location</span>
                      <Space wrap>
                        <Select
                          className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                          defaultValue="REMOTE"
                          value={jobDetails?.location}
                          onChange={(e) =>
                            handleJobDetailsChange(e, "location")
                          }
                          options={[
                            {
                              value: "REMOTE",
                              label: "REMOTE",
                            },
                            {
                              value: "ONSITE",
                              label: "ONSITE",
                            },
                            {
                              value: "HYBRID",
                              label: "HYBRID",
                            },
                          ]}
                        />
                      </Space>
                    </div>
                    {jobDetails?.location !== "REMOTE" && (
                      <div className="flex flex-col mb-2 space-y-4 mt-4">
                        <>
                          <div className="flex flex-col">
                            <span>Country</span>
                            <FormControl
                              className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                              sx={{ minWidth: 120 }}
                              size="small"
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={jobDetails?.country}
                                onChange={(value, option) => {
                                  handleJobDetailsChange(value, "country");
                                  getStatesByCountry(value);
                                }}
                                placeholder={
                                  jobDetails?.country
                                    ? jobDetails?.country
                                    : "Enter country"
                                }
                                options={countries.length > 0 && countries.map((country) => {
                                  return {
                                    value: country.iso2,
                                    label: country.name,
                                  };
                                })}
                              />
                            </FormControl>
                          </div>
                          <div className="flex flex-col">
                            <span>State</span>
                            <FormControl
                              className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                              sx={{ minWidth: 120 }}
                              size="small"
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value, otherInfo) => {
                                  // setStateIsoCode(otherInfo.isoCode);
                                  handleJobDetailsChange(value, "state");
                                  getCitiesByStateAndCountry(
                                    value,
                                    jobDetails.country
                                  );
                                }}
                                value={jobDetails?.state}
                                placeholder={
                                  jobDetails?.state
                                    ? jobDetails?.state
                                    : "Enter State"
                                }
                                options={states.length > 0 && states.map((individualstate) => {
                                  return {
                                    value: individualstate.iso2,
                                    label: individualstate.name,
                                  };
                                })}
                              />
                            </FormControl>
                          </div>
                          <div className="flex flex-col">
                            <span>City</span>
                            <FormControl
                              className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                              sx={{ minWidth: 120 }}
                              size="small"
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  handleJobDetailsChange(value, "city");
                                }}
                                value={jobDetails?.city}
                                placeholder={
                                  jobDetails?.city
                                    ? jobDetails?.city
                                    : "Enter City"
                                }
                                options={cities.map((individualcity) => {
                                  return {
                                    value: individualcity.name,
                                    label: individualcity.name,
                                  };
                                })}
                              />
                            </FormControl>
                          </div>
                        </>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col space-y-4">
                    <div className="flex flex-col">
                      <span>Select Project *</span>
                      <FormControl sx={{ minWidth: 120 }} size="small">
                        <Space wrap>
                          <Select
                            defaultValue="Select Project"
                            showSearch
                            filterOption={(inputValue, option) =>
                              option.value === "Add Project" ||
                              option.label
                                .toString()
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            allowClear
                            className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                            listHeight={128}
                            value={jobDetails.project === null ? "Default Project" : jobDetails?.project?.id}
                            onChange={(e) => {
                              setTempProjectId(e)
                              handleJobDetailsChange(e, "projectId");
                            }}
                            options={projects
                              .map((project) => {
                                return {
                                  value: project.id,
                                  label: project.title,
                                };
                              })
                              .concat([
                                {
                                  value: "Default Project",
                                  label: "Default Project",
                                },
                                {
                                  value: "Add Project",
                                  label: "+ Add Project",
                                },
                              ])}
                          />
                        </Space>
                      </FormControl>
                    </div>
                    <div className="flex flex-col space-y-4">
                      <div className="flex flex-col">
                        <span>Hourly Rate</span>
                        <FormControl
                          className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                          sx={{ minWidth: 120 }}
                          size="small"
                        >
                          <Input
                            placeholder="Enter Hourly Rate"
                            type="number"
                            value={jobDetails?.rate}
                            min={0}
                            className="h-[40px]"
                            onChange={(e) =>
                              handleJobDetailsChange(e.target.value, "rate")
                            }
                          />
                        </FormControl>
                      </div>
                      <div className="flex flex-col">
                        <span>Job Start Date *</span>
                        <FormControl
                          className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                          sx={{ minWidth: 120 }}
                          size="small"
                        >
                          <DatePicker
                            value={jobDetails?.start_date && moment(jobDetails?.start_date)}
                            onChange={(value) =>
                              handleJobDetailsChange(
                                value.format("YYYY-MM-DD"),
                                "start_date"
                              )
                            }
                            className="h-[40px]"
                            format="DD/MM/YYYY"
                          />
                        </FormControl>
                      </div>
                      <div className="flex flex-col">
                        <Tooltip placement="topLeft" title="Publish in Public Portal" color={"#2EBAA3"} key={"#2EBAA3"}>
                          <FormControlLabel control={<Checkbox checked={jobDetails.isPublicalyVisible} onChange={(e)=> handleJobDetailsChange(e.target.checked, "isPublicalyVisible")} />} label="Post in Find Jobs" />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2 mt-4">
                {/* <div className="flex justify-between md:space-x-2">
                  <div className="flex flex-col">
                    <span>City</span>
                    <FormControl
                      className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                      sx={{ minWidth: 120 }}
                      size="small"
                    >
                      <Input
                        placeholder="Enter City"
                        onChange={(e) =>
                          handleJobDetailsChange(e.target.value, "city")
                        }
                        className="h-[40px]"
                      />
                    </FormControl>
                  </div>
                  <div className="flex flex-col">
                    <span>State</span>
                    <FormControl
                      className="lg:w-[462px] md:w-[280px] sm:w-[200px]"
                      sx={{ minWidth: 120 }}
                      size="small"
                    >
                      <Input
                        placeholder="Enter State"
                        onChange={(e) =>
                          handleJobDetailsChange(e.target.value, "state")
                        }
                        className="h-[40px]"
                      />
                    </FormControl>
                  </div>
                </div> */}
              </div>
              <div className="my-4 flex flex-col">
                <button
                  style={{
                    maxWidth: "207px",
                    height: "54px",
                    width: "365px",
                    minWidth: "207px",
                    background:
                      jobDescriptionLength > 3000 ? "gray" : "#139588",
                    borderRadius: "6px",
                    color: "white",
                  }}
                  disabled={jobDescriptionLength > 3000}
                  type="submit"
                >
                  {(jobId && postJob) ? "Update Job" : "Create Job"}
                </button>
              </div>
            </form>
          ) : (
            <form
              onSubmit={(event) => {
                event.preventDefault();
                addProjectWrapper();
                event.target.reset();
              }}
              className="mt-8"
            >
              <div className="flex flex-col md:space-y-0 space-y-2">
                <span>Project Title</span>
                <input
                  className="border-[1px] border-[#C6C6C6] border-solid"
                  placeholder="Enter Project Title"
                  onChange={(e) => {
                    setProjects({
                      ...project,
                      projectTitle: e.target.value,
                    });
                  }}
                  style={{
                    borderRadius: "4px",
                    width: "100%",
                    height: "45px",
                    paddingLeft: "10px",
                  }}
                />
              </div>
              <div className="flex flex-col md:space-y-0 space-y-2 mt-8 ">
                <span>Project Details</span>
                <textarea
                  maxLength="250"
                  className="border-[1px] border-[#C6C6C6] border-solid"
                  onChange={(e) => {
                    setProjects({
                      ...project,
                      projectDetail: e.target.value,
                    });
                  }}
                  style={{
                    borderRadius: "4px",
                    width: "100%",
                    height: "154px",
                    paddingLeft: "10px",
                  }}
                />
              </div>

              <div className="mt-4 sm:space-x-4 sm:space-y-0 space-y-4"></div>
              <button
                style={{
                  maxWidth: "207px",
                  height: "54px",
                  width: "365px",
                  minWidth: "207px",
                  background: "#139588",
                  borderRadius: "6px",
                  color: "white",
                }}
                type="submit"
              >
                Create Project
              </button>
            </form>
          )}

          <Modal
            title="Add Project"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{
              hidden: true,
            }}
            cancelButtonProps={{
              hidden: true,
            }}
          >
            <form
              onSubmit={(event) => {
                event.preventDefault();
                addProjectWrapper();
                event.target.reset();
              }}
              className="mt-8"
            >
              <div className="flex flex-col md:space-y-0 space-y-2">
                <span>Project Title</span>
                <input
                  className="border-[1px] border-[#C6C6C6] border-solid"
                  placeholder="Enter Project Title"
                  onChange={(e) => {
                    setProjects({
                      ...project,
                      projectTitle: e.target.value,
                    });
                  }}
                  style={{
                    borderRadius: "4px",
                    width: "100%",
                    height: "45px",
                    paddingLeft: "10px",
                  }}
                />
              </div>
              <div className="flex flex-col md:space-y-0 space-y-2 mt-8 ">
                <span>Project Details</span>
                <textarea
                  className="border-[1px] border-[#C6C6C6] border-solid"
                  onChange={(e) => {
                    setProjects({
                      ...project,
                      projectDetail: e.target.value,
                    });
                  }}
                  style={{
                    borderRadius: "4px",
                    width: "100%",
                    height: "154px",
                    paddingLeft: "10px",
                  }}
                />
              </div>
              <div className="mt-4 sm:space-x-4 sm:space-y-0 space-y-4"></div>
              <button
                style={{
                  maxWidth: "207px",
                  height: "54px",
                  width: "365px",
                  minWidth: "207px",
                  background: "#139588",
                  borderRadius: "6px",
                  color: "white",
                }}
                type="submit"
              >
                Create Project
              </button>
            </form>
          </Modal>
        </>
      )}
    </div>
  );
}
